module.exports = __webpack_public_path__ + "static/media/Capital-Plus.9e56c37f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/Capital-Plus.jpg
// module id = 419
// module chunks = 0